<template>
  <div>
    <q-select
      outline
      v-model="selectedSector"
      :options="optionSectors"
      dense
      label="Choose Sectors"
      single
      input-debounce="0"
      option-label="name"
      option-value="symbol"
      class="ellipsis q-mr-sm row col-2"
      :menu-absolute="true"
      clearable
      style="width: 150px"
    />
  </div>
</template>

<script setup>
import useUtils from "src/use/utils";
import { ref, watch } from "vue";
import { useStore } from "vuex";
const emit = defineEmits(["emitedSector"]);
const props = defineProps({
  allStocks: {
    type: Array,
    default: () => [],
  },
});
const $store = useStore();
const { utilsOptionSectors } = useUtils();
const optionSectors = ref(utilsOptionSectors());
const selectedSector = ref("");

const mapSymbolsToSectors = (optionSectors, allStocks) => {
  optionSectors.value.forEach((sector) => {
    sector.stocks = [];
    allStocks.forEach((stock) => {
      if (sector.id === stock.sector) {
        sector.stocks.push(stock.symbol);
      }
    });
  });
};

mapSymbolsToSectors(optionSectors, props.allStocks);

watch(selectedSector, (newVal, oldVal) => {
  if (newVal == null) selectedSector.value = optionSectors.value[0];
  emit("emitedSector", selectedSector.value);
});
</script>
